<!--optradio : optional radio to display optional companies. value changed when clicked on '確認する' button.-->
<!--selectionStarted: true after initial welcome message-->
<template>
  <div
    style="height: 100vh; position: relative; overflow: hidden;"
    class="d-flex flex-column align-content-between mobile-container"
  >
    <div
      class="nav navbar py-4 font-24 font-weight-bold bg-custom d-flex justify-content-center"
    >
      <div class="w-50 text-center header" v-if="optradio === 'no'">
        <span class="text-white">登録が完了しました！</span>
      </div>
      <div
        class="w-50 text-left header"
        v-if="optradio === 'yes'"
        style="text-align:center!important"
      >
        <span class="text-white title">Bloomキャリア登録 導入企業一覧</span>
      </div>
    </div>

    <div
      class="d-flex justify-content-center body-content"
      v-if="optradio === 'no'"
    >
      <div class="w-50 d-flex align-items-center flex-column">
        <div class="mt-5 mb-5">
          <img
            src="../assets/images/confirm.svg"
            alt="thankyou image"
            class="img-fluid"
          />
        </div>
        <div class="d-flex flex-column">
          <p
            class="font-18 mb-4 font-weight-bold w-100"
            style="text-align:center"
          >
            「Bloomキャリア登録」を利用する大手企業各社へ登録が可能です<br />
            登録可能企業を次の画面でご確認ください
          </p>
        </div>
        <button
          class="btn btn-cstm btn-cstm-primary mt-2 h-auto py-2"
          @click="showOtherCompanies"
          :style="styleButton"
        >
          次へ（登録可能企業を表示）
        </button>
      </div>
    </div>

    <div
      class="pb-3"
      style="height: 100%; overflow-y: scroll; overflow-x: hidden;"
      v-if="optradio === 'yes'"
    >
      <div class="container py-3 d-flex align-items-center flex-column">
        <h5 class="font-16">キャリア登録を希望する企業を選択してください</h5>
        <div class="d-flex justify-content-center align-items-center">
          <input
            class="custom-checkbox mr-3"
            type="checkbox"
            v-model="selectAllCompaniesModel"
            id="select_all"
            name="select_all"
          />
          <label
            class="form-check-label font-16"
            for="select_all"
            style="padding-top: 3px"
          >
            すべて選択（全{{ companies.length }}社）
          </label>
        </div>
        <div class="companiesList">
          <div class="col-lg-12 mb-30 py-2">
            <!--even-->
            <div class="row">
              <div
                class="col-lg-6 col-md-6 py-1 border"
                v-for="(company, index) in companies"
                v-bind:key="company._id"
              >
                <div class="d-flex justify-content-between font-14">
                  <div class="d-flex align-items-center">
                    <div style="height: 20px; width: 20px;" class="mr-3">
                      <input
                        class="custom-checkbox"
                        type="checkbox"
                        :id="company._id"
                        :value="company._id"
                        name="other_companies"
                        v-model="other_companies"
                      />
                    </div>
                    <label
                      class="form-check-label font-14"
                      :for="company._id"
                      style="padding-top: 3px;"
                    >
                      {{ company.name }}
                    </label>
                  </div>
                  <div>
                    <i
                      v-b-toggle="`accordino0_${index}`"
                      class="fa fa-chevron-down"
                      aria-hidden="true"
                      style="height: 100%"
                    ></i>
                  </div>
                </div>
                <div>
                  <b-collapse
                    class="py-1"
                    v-bind:id="`accordino0_${index}`"
                    accordion="my-accordion"
                    role="tabpanel"
                  >
                    <b-card>
                      <span v-html="urlify(company.short_description)"> </span>
                    </b-card>
                  </b-collapse>
                </div>
              </div>
            </div>
            <!--odd-->
            <!-- <div class="col-md-6 p-0">
              <div class="col border py-1"
                   v-for="(company, index) in companies"
                   v-bind:key="company._id"
                   v-if="index % 2 !== 0">
                <div class="d-flex justify-content-between font-14">
                  <div class="d-flex align-items-center">
                    <div style="height: 20px; width: 20px;" class="mr-3">
                      <input class="custom-checkbox" type="checkbox" :id="company._id"
                             :value="company._id" name="other_companies"
                             v-model="other_companies">
                    </div>
                    <label class="form-check-label font-14" :for="company._id" style="padding-top: 3px;">
                      {{ company.name }}
                    </label>
                  </div>
                  <div>
                    <i
                        v-b-toggle="`accordino0_${index}`"
                        class="fa fa-chevron-down"
                        aria-hidden="true"
                        style="height: 100%"
                    ></i>
                  </div>
                </div>
                <div>
                  <b-collapse
                      class="py-1"
                      v-bind:id="`accordino0_${index}`"
                      accordion="my-accordion"
                      role="tabpanel"
                  >
                    <b-card>
                        <span
                            v-html="
                            urlify(company.short_description)
                          ">
                        </span>
                    </b-card>
                  </b-collapse>
                </div>
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </div>

    <div class="stickyFooter" v-if="optradio === 'yes'">
      <div
        class="py-sm-3 py-2 pb-sm-4 border w-100 bg-white d-flex justify-content-center"
      >
        <a
          :href="MEDIA_URL"
          class="d-inline-flex align-items-center text-gray pt-sm-0 pt-2"
          >選択せず終了する</a
        >
        <button
          class="btn text-white btn-sm py-2 px-5 rounded mx-5 custom-btn confirmBtn"
          @click="confirm"
        >
          企業登録に進む
        </button>
      </div>
    </div>

    <b-modal
      ref="confirmModal"
      hide-header
      hide-footer
      centered
      size="lg"
      @hidden="hideModal"
    >
      <!-- <div class="swal-icon">
        <div class="swal-icon--success__line swal-icon--success__line--long"></div>
        <div class="swal-icon--success__line swal-icon--success__line--tip"></div>
        <div class="swal-icon--success__ring"></div>
        <div class="swal-icon--success__hide-corners"></div>
      </div> -->
      <div class="swal-title" style="color:#000">
        以下企業へキャリア登録しますか？
      </div>
      <div class="swal-content mt-0">
        <div class="mx-md-5 p-3 d-flex flex-column">
          <span
            class="swal-text m-0 font-20 mb-2"
            style="color:#000"
            v-for="name in selectedCompanyName"
            >{{ name }}</span
          >
        </div>
        <div class="mx-md-5 rounded text-left p-3" style="background: #dee9f5;">
          <p class="notice-list-header"
          >
            ご自身の在籍企業など、情報を公開したくない企業が含まれていないか十<span>分注意してください。</span>
          </p>
          <br />
          <ul class="notice-list">
            <li>
              キャリア登録フォームで既に入力いただいた情報が、登録企業へ公開されます。
            </li>
            <li>
              登録企業は、ユーザーが他に登録している企業を確認することはできません。
            </li>
            <li>
              ユーザーの承諾無しに、登録企業以外へ情報が公開されることはありません。
            </li>
          </ul>
          <!-- <p style="text-align: center;margin-bottom:5px">
            ・キャリア登録フォームで既に入力いただいた情報が、登録企業へ公開されます。
          </p>
          <p style="text-align: center;margin-bottom:5px">
            ・登録企業は、ユーザーが他に登録している企業を確認することはできません。
          </p>
          <p style="text-align: center;margin-bottom:5px">
            ・ユーザーの承諾無しに、登録企業以外へ情報が公開されることはありません。
          </p> -->
        </div>
      </div>
      <div
        class="swal-footer d-flex justify-content-center custom-modal-footer full"
      >
        <button
          class="btn text-white btn-sm rounded py-2 px-5 mx-lg-5 mx-1 font-14 font-bold cancelBtn w-230"
          @click="shareCompanyResponse(false)"
        >
          企業選択に戻る
        </button>
        <button
          class="btn text-white btn-sm rounded py-2 px-5 mx-lg-5 mx-1 font-12 text-center confirmBtn w-230"
          @click="shareCompanyResponse(true)"
        >
          注意事項に同意して <br />
          <span class="font-bold font-14">登録する</span>
        </button>
      </div>
      <div
        class="swal-footer d-flex justify-content-center custom-modal-footer mobile"
      >
        <button
          class="btn text-white btn-sm rounded py-2 px-5 mx-lg-5 mx-1 font-12 text-center confirmBtn w-230 mb-2"
          @click="shareCompanyResponse(true)"
        >
          <span style="font-size:14px">注意事項に同意して</span> <br />
          <span class="font-bold font-18">登録する</span>
        </button>
        <button
          class="btn text-white btn-sm rounded py-2 px-5 mx-lg-5 mx-1 font-14 cancelBtn w-230"
          @click="shareCompanyResponse(false)"
        >
          企業選択に戻る
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Api from '@/config/api';
import swal from 'sweetalert';
import logo from '../assets/Group300.png';

export default {
  data() {
    return {
      token: this.$route.params.token,
      user_id: this.$route.params.id,
      companies: [],
      selectAllCompaniesModel: false,
      other_companies: [],
      optradio: 'no',
      selectionStarted: false,
      companyData: undefined,
      selectedCompanyName: [],
    };
  },
  computed: {
    o_companies() {
      if (this.optradio === 'no') {
        return [];
      }
      return this.other_companies;
    },
    styleButton() {
      // return (this.companyData && this.companyData.brand_secondary_color) ? {
      //       'background': this.companyData.brand_secondary_color,
      //       'border-color': this.companyData.brand_secondary_color
      //     }
      //     : {
      //       'background': '#000000',
      //       'border-color': '#000000'
      //     };
      return {
        background: 'red',
        'border-color': 'red',
      };
    },
    MEDIA_URL() {
      return Api.MEDIA_URL || '';
    },
  },
  watch: {
    selectAllCompaniesModel(check) {
      if (check) this.selectAllCompanies();
      else this.unselectAllcompanies();
    },
  },
  methods: {
    shareCompanyResponse(result) {
      if (result) {
        this.afterVerify();
      }
      this.$refs.confirmModal.hide();
    },
    hideModal() {
      this.selectedCompanyName = [];
    },
    exit() {
      this.optradio = 'no';
      this.other_companies = [];
    },
    async exitWithoutSelection() {
      await swal({
        title: '企業が選択されていません。',
        text: '',
        icon: 'warning',
        className: '',
        button: {
          text: '戻る',
          value: false,
          visible: true,
          closeModal: true,
        },
      });
    },
    scrollToTop() {
      // scroll to top
      window.scrollTo(0, 0);
    },
    async confirm() {
      this.scrollToTop();
      if (this.other_companies.length > 0 && this.optradio === 'yes') {
        this.other_companies.forEach((comp, index) => {
          const resultedCompany = this.companies.find(com => com._id === comp);
          this.selectedCompanyName.push(`${index + 1}. ${resultedCompany.name}`);
        }, this);
        this.$refs.confirmModal.show();
      } else {
        await this.exitWithoutSelection();
      }
    },
    async verify() {
      try {
        if (!this.token || !this.user_id) {
          this.$router.push({ name: 'pageNotFound' });
        } else {
          const result = await this.axios({
            method: 'post',
            data: {
              token: this.token,
              id: this.user_id,
            },
            url: Api.url(Api.endpoints.VerifyEmail),
          });
          this.companies = result.data.data.companies;
          this.companyData = result.data.data.company;
          if (this.companies.length === 0) this.$router.push({ name: 'login' });
          // else this.selectionStarted = true;
        }
      } catch (error) {
        if (error.response.status === 400) {
          await swal({
            text: 'このリンクは期限切れか無効になっています。',
            icon: 'warning',
            buttons: {
              ok: 'はい',
            },
          });
          this.$router.push({ name: 'login' });
        }
      }
    },
    async afterVerify() {
      try {
        if (!this.token || !this.user_id) { this.$router.push({ name: 'pageNotFound' }); } else {
          await this.axios({
            method: 'post',
            data: {
              token: this.token,
              id: this.user_id,
              other_companies: this.o_companies,
              first_time_registration: true,
            },
            url: Api.url(`${Api.endpoints.afterVerifyEmail}?selectAll=${this.selectAllCompaniesModel}`),
          });
          await swal({
            title: '登録が完了しました。',
            text: '適したポジションやイベントがある際に個別に連絡が届きます。',
            icon: logo,
            className: 'custom-swal7',
          });
          window.location.href = Api.MEDIA_URL;
        }
      } catch (error) {
        if (error.response.status === 400) {
          await swal({
            text: 'このリンクは期限切れか無効になっています。',
            icon: 'warning',
            buttons: {
              ok: 'はい',
            },
          });
          this.$router.push({ name: 'login' });
        } else if (error.response.status === 503) {
          this.$router.push({ name: 'Logout' });
        }
      }
    },
    selectAllCompanies() {
      this.other_companies = this.companies.map(company => company._id);
    },
    unselectAllcompanies() {
      this.other_companies = [];
    },
    urlify(description) {
      const urlRegex = /(https?:\/\/)?[\w\-~]+(\.[\w\-~]+)+(\/[\w\-~@:%]*)*(#[\w\-]*)?(\?[^\s]*)?/gi;
      return description.replace(urlRegex, url => `<a href="${url}" target="_blank">${url}</a>`);
    },
    showOtherCompanies() {
      // this.selectionStarted = true;
      this.optradio = 'yes';
    },
  },
  created() {
    this.verify();
  },
  metaInfo() {
    let title;
    if (this.optradio == 'no') {
      title = '登録完了';
    } else {
      title = 'Bloomキャリア登録導入企業一覧 導入企業一覧';
    }
    return {
      title: `${title} | Bloomキャリア登録`,
    };
  },
};
</script>
<style scoped>
.notice-list-header{
  color:#DD3847;
  margin-top: 12px;
  text-align: center;
  font-weight: bold;
  font-size: 24px;
}
.notice-list{
  margin-left: -20px;
  line-height: 30px;
}
.mobile {
  display: none !important;
}
.bg-custom {
  background-color: #076d6c;
}

.font-24 {
  font-size: 24px;
}

.font-18 {
  font-size: 18px;
}

.font-15 {
  font-size: 15px;
}

.btn-cstm {
  padding: 15px 20px;
  width: 343px;
  border-radius: 8px;
  height: 55px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 900;
  color: #fff !important;
}

.overlay {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
}

@media only screen and (max-width: 992px) {
  .navbar > div,
  .body-content > div {
    width: 75% !important;
  }
}

@media only screen and (max-width: 576px) {
  .navbar > div,
  .body-content > div {
    width: 100% !important;
    padding-left: 1rem;
    padding-right: 1rem;
  }
}
@media (max-width: 550px) {

  .mobile-container {
    height: 93vh !important;
  }
  .full {
    display: none !important;
  }
  .mobile {
    display: block !important;
    text-align: center;
  }
  .text-white {
    font-size: 20px;
  }
  .notice-list-header{
    font-size: 22px;
  }
  .custom-btn{
    font-size: 18px !important;
  }
  .swal-title{
    font-size:22px;
  }

  >>> .modal-body{
    padding: 10px 0px 10px 0px;
  }
  .swal-content{
    padding: 10px 0px 10px 0px;
  }
}
.big-checkbox {
  height: 20px;
  width: 20px;
}

.psmall {
  font-size: 0.875rem;
}
.form-check-label {
  margin-bottom: 0;
  font-size: 1.25rem;
}
.confirm-logo {
  max-height: 50px;
}

.background-color {
  background: rgba(0, 0, 0, 0.4);
}
/* button.swal-button.swal-button--confirm {
      color: #fff;
      background-color: #dc3545;
      border-color: #dc3545;
  } */
/* .swal-text {
    font-size: 36px;
  } */

@media (max-width: 767px) {
  .left_align {
    text-align: left !important;
  }
  .line__break {
    display: none;
  }
}

@media (min-width: 1200px) {
  >>> .modal-xl {
    max-width: 1140px !important;
  }
}

.companiesList {
  width: 75%;
}

@media (max-width: 991px) {
  .companiesList {
    width: 100%;
  }
}

.font-18 {
  font-size: 18px !important;
}

.font-16 {
  font-size: 16px !important;
}

.font-14 {
  font-size: 14px !important;
}

.font-20 {
  font-size: 20px !important;
}

.font-bold {
  font-weight: bold;
}

@media (max-width: 577px) {
  .stickyFooter > div {
    flex-direction: column-reverse !important;
    align-items: center;
  }

  >>> .custom-modal-footer-mobile {
    flex-direction: column !important;
    align-items: center;
  }

  .stickyFooter > div > button:nth-child(1),
  >>> .custom-modal-footer-mobile > button:nth-child(1) {
    margin-bottom: 0.5rem !important;
  }
}

.text-gray {
  color: gray;
}

.custom-btn {
  font-size: 14px;
  font-weight: bold;
}

.cancelBtn {
  background: #666666;
  border: 1px solid #666666;
}

.cancelBtn:hover {
  background: #494949 !important;
}

.confirmBtn {
  background: #ff0000;
  border: 1px solid #ff0000;
}

.confirmBtn:hover {
  background: #c20101 !important;
}

.w-230 {
  width: 230px;
}

>>> .custom-checkbox {
  width: 20px;
  height: 20px;
}
</style>
